import { CommonModule } from '@angular/common';
import { Inject, InjectionToken, ModuleWithProviders, NgModule, Optional } from '@angular/core';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslocoModule } from '@ngneat/transloco';
import { TranslocoMarkupModule } from 'ngx-transloco-markup';
import { ButtonModule } from '../button';
import { IconsModule } from '../icons';
import { NotificationModule } from '../notification';
import { TooltipModule } from '../tooltip';
import { ModalContainerComponent } from './modal-container/modal-container.component';
import { ModalHostDirective } from './modal-host.directive';
import { ModalRegistryService } from './modal-registry.service';
import { ModalComponent } from './modal/modal.component';

@NgModule({
  declarations: [ModalComponent, ModalContainerComponent, ModalHostDirective],
  imports: [ButtonModule, CommonModule, IconsModule, NgbModalModule, NotificationModule, TooltipModule, TranslocoModule, TranslocoMarkupModule],
  exports: [ModalComponent]
})
export class ModalModule {
  private static MODALS = new InjectionToken('MODALS');

  constructor(modalRegistryService: ModalRegistryService, @Inject(ModalModule.MODALS) @Optional() modals: Record<symbol, any>[] | null) {
    modalRegistryService.register(modals);
  }

  static withModals(modals: Record<symbol, any>): ModuleWithProviders<ModalModule> {
    return {
      ngModule: ModalModule,
      providers: [{ provide: ModalModule.MODALS, useValue: modals, multi: true }]
    };
  }
}
